var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMenuStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Star_Line",
    "data-name": "icons/Star/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.988,6.817a.7.7,0,0,1-.59.428l-4.749.379a.7.7,0,0,0-.4,1.23l3.614,3.084a.7.7,0,0,1,.226.7l-1.1,4.614a.7.7,0,0,0,1.045.761L10.1,15.532a.7.7,0,0,1,.728,0L14.9,18.01a.7.7,0,0,0,1.045-.761l-1.1-4.614a.7.7,0,0,1,.226-.7l3.614-3.084a.7.7,0,0,0-.4-1.23l-4.749-.379a.7.7,0,0,1-.59-.428L11.111,2.43a.7.7,0,0,0-1.292,0Zm6.5-1.5L12.957,1.66a2.7,2.7,0,0,0-4.983,0L6.448,5.314l-3.959.316A2.7,2.7,0,0,0,.951,10.376L3.96,12.943l-.919,3.84a2.7,2.7,0,0,0,4.029,2.935l3.4-2.066,3.4,2.066a2.7,2.7,0,0,0,4.029-2.935l-.919-3.84,3.008-2.567a2.7,2.7,0,0,0-1.538-4.745Z",
    transform: "translate(1.535 2.117)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenuStar);
export default __webpack_public_path__ + "static/media/accountMenuStar.6abd9310732ba7b957b015f7c3f883e0.svg";
export { ForwardRef as ReactComponent };